import React, { useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Col, Row, Form, Select, Input, Button, notification } from "antd";

import styles from "./styles.module.css";

export const FinderTaxpayers = (props) => {
  const { doSearch, viewSearch = true } = props;
  const regexNoSpace = /^\S+$/;
  const regexWithoutSpecialCharsAndNumbers = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;
  const regexEmail = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

  const [form] = Form.useForm();
  const [searchLoading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [filter, setFilter] = useState(viewSearch ? "skid" : 'rfc');

  const handleFilter = (value) => setFilter(value);

  const typeInput = () => {
    switch (filter) {
      case "skid":
        return "number";
      case "email":
        return "email";
      case "phone_number":
        return "number";
      default:
        return "text";
    }
  };

  const filterOptions = (
    <Form.Item name="filters" noStyle>
      <Select className={styles.filterSelect} style={{ width: "100px" }} onChange={handleFilter}>
        {viewSearch && <Select.Option value="skid">SKID</Select.Option>}
        <Select.Option value="rfc">RFC</Select.Option>
        {viewSearch && (
          <>
            <Select.Option value="name">Nombre</Select.Option>
            <Select.Option value="email">Correo</Select.Option>
            <Select.Option value="phone_number">Teléfono</Select.Option>
          </>
        )}
      </Select>
    </Form.Item>
  );

  const fetchUsers = () => {
    setLoading(true);
    if (filter === "rfc") {
      doSearch(filter, value.toUpperCase(), 1);
      // if (regexNoSpace.test(value)) {
      //   doSearch(filter, value.toUpperCase(), 1);
      // } else {
      //   notification.error({
      //     message: "RFC inválido",
      //     description: "Introduce un RFC válido.",
      //   });
      // }
    } else if (filter === "name") {
      if (regexWithoutSpecialCharsAndNumbers.test(value)) {
        doSearch(filter, value, 1);
      } else {
        notification.error({
          message: "Nombre inválido",
          description: "Introduce un Nombre válido.",
        });
      }
    } else if (filter === "email") {
      if (regexEmail.test(value)) {
        doSearch(filter, value, 1);
      } else {
        notification.error({
          message: "Correo electrónico inválido",
          description: "Introduce un correo electrónico válido.",
        });
      }
    } else {
      doSearch(filter, value, 1);
    }
    setTimeout(() => setLoading(false), 3000);
  };

  const SearchButton = () => (
    <Button
      className={styles.searchButton}
      type="primary"
      icon={<SearchOutlined />}
      onClick={fetchUsers}
      loading={searchLoading}
    >
      Buscar
    </Button>
  );

  return (
    <Row className={styles.containerFinder}>
      <Form
        className={styles.formFinder}
        style={{ marginTop: "2%", paddingLeft: "10%", paddingRight: "10%" }}
        form={form}
        name="Finder"
        initialValues={{
          filters: viewSearch ? "skid" : "rfc",
        }}
        scrollToFirstError
      >
        <Form.Item
          className={styles.containerInputSearch}
          name="search"
          label="Buscar usuario por: "
          rules={[{ required: false, message: "Utiliza un filtro para buscar al usuario" }]}
        >
          <Row>
            <Col className={styles.input}>
              <Input
                addonBefore={filterOptions}
                className={styles.inputFilter}
                type={typeInput()}
                value={filter === "rfc" ? value.toUpperCase() : value}
                onChange={(event) =>
                  setValue(filter === "rfc" ? event.target.value.replaceAll(" ", "") : event.target.value)
                }
              />
            </Col>
            <Col className={styles.button}>
              <SearchButton />
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Row>
  );
};
